"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var TypographyContext = /*#__PURE__*/_react["default"].createContext(null);

var Typography = function Typography(_ref) {
  var as = _ref.as,
      display = _ref.display,
      fontFamily = _ref.fontFamily,
      fontSize = _ref.fontSize,
      fontStyle = _ref.fontStyle,
      fontWeight = _ref.fontWeight,
      letterSpacing = _ref.letterSpacing,
      lineHeight = _ref.lineHeight,
      textAlign = _ref.textAlign,
      color = _ref.color,
      textDecoration = _ref.textDecoration,
      textOverflow = _ref.textOverflow,
      whiteSpace = _ref.whiteSpace,
      children = _ref.children;
  var componentContext = (0, _react.useContext)(TypographyContext);
  var asValue = as !== null && as !== void 0 ? as : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.as) || "span";
  var displayValue = display !== null && display !== void 0 ? display : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.display) || "inline";
  var fontFamilyValue = fontFamily !== null && fontFamily !== void 0 ? fontFamily : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.fontFamily) || "Open Sans, sans-serif";
  var fontSizeValue = fontSize !== null && fontSize !== void 0 ? fontSize : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.fontSize) || "1rem";
  var fontStyleValue = fontStyle !== null && fontStyle !== void 0 ? fontStyle : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.fontStyle) || "normal";
  var fontWeightValue = fontWeight !== null && fontWeight !== void 0 ? fontWeight : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.fontWeight) || "400";
  var letterSpacingValue = letterSpacing !== null && letterSpacing !== void 0 ? letterSpacing : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.letterSpacing) || "0em";
  var lineHeightValue = lineHeight !== null && lineHeight !== void 0 ? lineHeight : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.lineHeight) || "1.5em";
  var textAlignValue = textAlign !== null && textAlign !== void 0 ? textAlign : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.textAlign) || "left";
  var colorValue = color !== null && color !== void 0 ? color : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.color) || "#000000";
  var textDecorationValue = textDecoration !== null && textDecoration !== void 0 ? textDecoration : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.textDecoration) || "none";
  var textOverflowValue = textOverflow !== null && textOverflow !== void 0 ? textOverflow : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.textOverflow) || "unset";
  var whiteSpaceValue = whiteSpace !== null && whiteSpace !== void 0 ? whiteSpace : (componentContext === null || componentContext === void 0 ? void 0 : componentContext.whiteSpace) || "normal";
  return /*#__PURE__*/_react["default"].createElement(TypographyContext.Provider, {
    value: {
      as: asValue,
      display: displayValue,
      fontFamily: fontFamilyValue,
      fontSize: fontSizeValue,
      fontStyle: fontStyleValue,
      fontWeight: fontWeightValue,
      letterSpacing: letterSpacingValue,
      lineHeight: lineHeightValue,
      textAlign: textAlignValue,
      color: colorValue,
      textDecoration: textDecorationValue,
      textOverflow: textOverflowValue,
      whiteSpace: whiteSpaceValue
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledTypography, {
    as: asValue,
    display: displayValue,
    fontFamily: fontFamilyValue,
    fontSize: fontSizeValue,
    fontStyle: fontStyleValue,
    fontWeight: fontWeightValue,
    letterSpacing: letterSpacingValue,
    lineHeight: lineHeightValue,
    textAlign: textAlignValue,
    color: colorValue,
    textDecoration: textDecorationValue,
    textOverflow: textOverflowValue,
    whiteSpace: whiteSpaceValue
  }, children));
};

var StyledTypography = _styledComponents["default"].span(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0px;\n  display: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-style: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  text-align: ", ";\n  line-height: ", ";\n  text-decoration: ", ";\n  text-overflow: ", ";\n  white-space: ", ";\n  overflow: ", ";\n"])), function (_ref2) {
  var display = _ref2.display;
  return display;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var fontFamily = _ref4.fontFamily;
  return fontFamily;
}, function (_ref5) {
  var fontSize = _ref5.fontSize;
  return fontSize;
}, function (_ref6) {
  var fontStyle = _ref6.fontStyle;
  return fontStyle;
}, function (_ref7) {
  var fontWeight = _ref7.fontWeight;
  return fontWeight;
}, function (_ref8) {
  var letterSpacing = _ref8.letterSpacing;
  return letterSpacing;
}, function (_ref9) {
  var textAlign = _ref9.textAlign;
  return textAlign;
}, function (_ref10) {
  var lineHeight = _ref10.lineHeight;
  return lineHeight;
}, function (_ref11) {
  var textDecoration = _ref11.textDecoration;
  return textDecoration;
}, function (_ref12) {
  var textOverflow = _ref12.textOverflow;
  return textOverflow;
}, function (_ref13) {
  var whiteSpace = _ref13.whiteSpace,
      textOverflow = _ref13.textOverflow;
  return whiteSpace !== "normal" ? whiteSpace : textOverflow !== "unset" ? "nowrap" : "normal";
}, function (_ref14) {
  var textOverflow = _ref14.textOverflow;
  return textOverflow !== "unset" ? "hidden" : "visible";
});

var _default = Typography;
exports["default"] = _default;